import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { ReviewAndRating } from './faq.types';

export interface ReviewPayload {
  reviewId: string;
}

const deleteUserRatings = (client: AxiosInstance) => async (payload: ReviewPayload) => {
  return (
    await client.post<{ message: string; data: ReviewAndRating }>(API_ROUTES.DELETE_USER_RATINGS, null, {
      params: { reviewId: payload.reviewId },
    })
  ).data;
};

export const faqMutations = {
  deleteUserRatings,
};
